import actionTypes from "../webActionTypes";

const reducers = {
    [actionTypes.beginCreateInvoice]: function (state, action) {
      return beginCreateInvoice(state, action);
    },
    [actionTypes.recvCreateInvoiceResult]: function (state, action) {
        return recvCreateInvoiceResult(state, action);
    },
    [actionTypes.recvCreateInvoiceError]: function (state, action) {
        return recvCreateInvoiceError(state, action);
    },
    [actionTypes.beginFailInvoice]: function (state, action) {
        return beginFailInvoice(state, action);
    },
    [actionTypes.recvFailInvoiceResult]: function (state, action) {
        return recvFailInvoiceResult(state, action);
    },
    [actionTypes.recvFailInvoiceError]: function (state, action) {
        return recvFailInvoiceError(state, action);
    },
    [actionTypes.beginGetInvoiceList]: function (state, action) {
        return beginGetInvoiceList(state, action);
    },
    [actionTypes.recvGetInvoiceListResult]: function (state, action) {
        return recvGetInvoiceListResult(state, action);
    },
    [actionTypes.recvGetInvoiceListError]: function (state, action) {
        return recvGetInvoiceListError(state, action);
    },
    [actionTypes.beginGetInvoiceInfo]: function (state, action) {
        return beginGetInvoiceInfo(state, action);
    },
    [actionTypes.recvGetInvoiceInfoResult]: function (state, action) {
        return recvGetInvoiceInfoResult(state, action);
    },
    [actionTypes.recvGetInvoiceInfoError]: function (state, action) {
        return recvGetInvoiceInfoError(state, action);
    },    
    [actionTypes.beginGetOrderInvoiceInfo]: function (state, action) {
        return beginGetOrderInvoiceInfo(state, action);
    },
    [actionTypes.recvGetOrderInvoiceInfoResult]: function (state, action) {
        return recvGetOrderInvoiceInfoResult(state, action);
    },
    [actionTypes.recvGetOrderInvoiceInfoError]: function (state, action) {
        return recvGetOrderInvoiceInfoError(state, action);
    },
    // 開啟下載發票媒體申報檔Dialog
    [actionTypes.openDownloadTaxMediaDialog]: function(state, action) {
        return openDownloadTaxMediaDialog(state, action);
    },
    // 關閉下載發票媒體申報檔Dialog
    [actionTypes.closeDownloadTaxMediaDialog]: function(state, action) {
        return closeDownloadTaxMediaDialog(state, action);
    },
    [actionTypes.finishUpdateInvoiceStatus]: function(state, action) {
        return finishUpdateInvoiceStatus(state, action);
    },
    [actionTypes.finishGetInvoiceItemYearmonthList]: function (state, action) {
        return finishGetInvoiceItemYearmonthList(state, action);
    },
};

export default function createReducers(initialState) {
    return function reducer(state = initialState, action) {
        if (reducers.hasOwnProperty(action.type)) {
            return reducers[action.type](state, action);
        } else {
            return state;
        }
    };
}

function beginGetInvoiceList(state, action) {

    if (state.isLoadingInvoiceList) return state;

    return Object.assign({}, state, {
        isLoadingInvoiceList: true
    });
}

function recvGetInvoiceListResult(state, action) {

    const {
        payload
    } = action;

    const {totalCount, querykey, ids, data} = payload;

    if (ids.length === 0) {
        return state;
    }
    
    var invoiceList;

    if(querykey === state.querykey) {
        invoiceList = Object.assign({}, state.invoiceList, ids);        
    } else {
        invoiceList = Object.assign({}, {}, ids);
    }

    const invoices = Object.assign({}, state.invoices, data);

    return Object.assign({}, state, {
        invoiceList,
        invoices,
        totalCount,
        querykey,
        isLoadingInvoiceList: false,
    });
}

function recvGetInvoiceListError(state, action) {
    
    if (!state.isLoadingInvoiceList) return state;

    return Object.assign({}, state, {
        isLoadingInvoiceList: false
    });
}

function beginCreateInvoice(state, action) {

    if (state.isCreateInvoice) return state;

    return Object.assign({}, state, {
        isCreateInvoice: true
    });
}

function recvCreateInvoiceResult(state, action) {

    if (!state.isCreateInvoice) return state;

    return Object.assign({}, state, {
        isCreateInvoice: false,
    });
}

function recvCreateInvoiceError(state, action) {

    if (!state.isCreateInvoice) return state;

    return Object.assign({}, state, {
        isCreateInvoice: false,
    });
}

function beginFailInvoice(state, action) {

    if (state.isFailInvoice) return state;

    return Object.assign({}, state, {
        isFailInvoice: true
    });
}

function recvFailInvoiceResult(state, action) {

    if (!state.isFailInvoice) return state;
    const key = action.payload.istarttag+action.payload.invoicenumber;
    // Fail Invoice 
    const invoice = state.invoices[key];
    // change detail
    const detail = Object.assign({}, invoice.detail, {ifailstatus: '1'});
    // change invoice
    const newinvoice = Object.assign({}, invoice, {detail});
    // change invoices
    const newinvoices = Object.assign({}, state.invoices, {[key]: newinvoice});

    return Object.assign({}, state, {
        invoices: newinvoices,
        isFailInvoice: false,
    });
}

function recvFailInvoiceError(state, action) {

    if (!state.isFailInvoice) return state;

    return Object.assign({}, state, {
        isFailInvoice: false,
    });
}

function beginGetInvoiceInfo(state, action) {

    if (state.isLoadingInvoiceInfo) return state;

    return Object.assign({}, state, {
        isLoadingInvoiceInfo: true
    });
}

function recvGetInvoiceInfoResult(state, action) {

    const {
        payload
    } = action;

    if(!payload)
        return state;

    const id = payload.istarttag + payload.invoicenumber;
    const invoice = state.invoices[id] || {};
    const newinvoice = Object.assign(invoice, payload);
    const invoices = Object.assign({}, state.invoices, {[id]: newinvoice});

    return Object.assign({}, state, {
        invoices,
        isLoadingInvoiceInfo: false,
    });
}


function recvGetInvoiceInfoError(state, action) {
    
    if (!state.isLoadingInvoiceInfo) return state;

    return Object.assign({}, state, {
        isLoadingInvoiceInfo: false,
    });
}

function beginGetOrderInvoiceInfo(state, action) {

    if (state.isLoadingOrderInvoiceInfo) return state;

    return Object.assign({}, state, {
        isLoadingOrderInvoiceInfo: true,
    });
}

function recvGetOrderInvoiceInfoResult(state, action) {

    const {
        payload
    } = action;

    if(!payload)
        return state;

    const id = payload.orderid;
    const invoice = state.orderInvoices[id] || {};
    const newinvoice = Object.assign(invoice, payload);
    const orderInvoices = Object.assign({}, state.orderInvoices, {[id]: newinvoice});

    return Object.assign({}, state, {
        orderInvoices,
        isLoadingOrderInvoiceInfo: false,
    });
}

function recvGetOrderInvoiceInfoError(state, action) {
    
    if (!state.isLoadingOrderInvoiceInfo) return state;

    return Object.assign({}, state, {
        isLoadingOrderInvoiceInfo: false,
    });
}

// ------------------------------
// 開啟下載發票媒體申報檔Dialog
// ------------------------------
function openDownloadTaxMediaDialog(state, action) {

    var downloadTaxMediaDialog = state.downloadTaxMediaDialog;

    if(downloadTaxMediaDialog.isOpen) {
        return state;
    }

    var new_downloadTaxMediaDialog = Object.assign({}, downloadTaxMediaDialog, {
        isOpen: true,
    });

    return Object.assign({}, state, {
        downloadTaxMediaDialog: new_downloadTaxMediaDialog,
    });
}

// ------------------------------
// 關閉下載發票媒體申報檔Dialog
// ------------------------------
function closeDownloadTaxMediaDialog(state, action) {

    var downloadTaxMediaDialog = state.downloadTaxMediaDialog;

    if(!downloadTaxMediaDialog.isOpen) {
        return state;
    }

    var new_downloadTaxMediaDialog = Object.assign({}, downloadTaxMediaDialog, {
        isOpen: false,
    });

    return Object.assign({}, state, {
        downloadTaxMediaDialog: new_downloadTaxMediaDialog,
    });
}

function finishUpdateInvoiceStatus(state, action) {

    const payload = action.payload;

    const {
        istarttag,
        invoiceNumber,
        istatus,
    } = payload;

    const key = istarttag + invoiceNumber;
    const invoices = state.invoices;
    const invoice = invoices[key];
    const detail = Object.assign({}, invoice.detail, {
        istatus: istatus,
    });
    const new_invoice = Object.assign({}, invoice, {
        detail: detail,
    });
    const new_invoices = Object.assign({}, invoices, {
        [key]: new_invoice
    });

    return Object.assign({}, state, {
        invoices: new_invoices,
    });
}

function finishGetInvoiceItemYearmonthList(state, action) {

    const payload = action.payload;
    const yearmonthList = payload.yearmonthList || [];

    return Object.assign({}, state, {
        yearmonthList: yearmonthList,
    });
}




// WEBPACK FOOTER //
// ./src/actions/reducers/invoiceReducers.js